import cls from "classname"

import Bone from "../Skeleton/Bone"
import KpiTab from "./KpiTab"

import styles from "./kpiTabs.module.less"

// A tab's lines at their rendered heights: label, value, secondary and, while a comparison
// will come back with the figures, the comparison line.
const KpiTabSkeleton = ({ withComparison }) => (
  <div className={cls(styles.tab, styles.readOnly)}>
    <span className={styles.skeletonLine}>
      <Bone width={110} height={14} />
    </span>
    <span className={styles.skeletonValue}>
      <Bone width={96} height={24} />
    </span>
    <span className={styles.skeletonLine}>
      <Bone width={150} height={14} />
    </span>
    {withComparison && (
      <span className={styles.skeletonLine}>
        <Bone width={180} height={14} />
      </span>
    )}
  </div>
)

// The dashboard headline row: one clickable tab per KPI, hairline-divided, over the chart of
// the selected one (`children`). Knows nothing of where the figures come from — each page maps
// its own answer onto `tabs` (see KpiTab for the shape). `loading` draws `skeletonCount` tabs;
// `withComparison` says whether the request carries a comparison, so the skeleton is as tall
// as the tabs it stands in for.
const KpiTabs = ({
  tabs,
  selectedKey,
  onSelect,
  loading,
  skeletonCount = 4,
  withComparison,
  children
}) => (
  <div className={styles.section}>
    {loading ? (
      <div className={styles.tabs} style={{ "--kpi-cols": skeletonCount }}>
        {Array.from({ length: skeletonCount }, (_, i) => (
          <KpiTabSkeleton key={i} withComparison={withComparison} />
        ))}
      </div>
    ) : tabs.length ? (
      <div className={styles.tabs} style={{ "--kpi-cols": tabs.length }}>
        {tabs.map((tab) => (
          <KpiTab key={tab.key} tab={tab} active={tab.key === selectedKey} onSelect={onSelect} />
        ))}
      </div>
    ) : null}
    {children ? <div className={styles.chart}>{children}</div> : null}
  </div>
)

export default KpiTabs
